module.exports = __webpack_public_path__ + "img/QRcode.d9e6674a.png";